export default {
  watch: {
    stepValid(valid) {
      this.$formController.setCurrentStepValidation(valid)
    }
  },
  created() {
    this.$formController.setCurrentStepValidation(this.stepValid)
  }
}